/**
 * billing-format.ts — helper presentasi billing (plan 19 Fase 1).
 *
 * Dipisah dari komponen supaya bisa diuji tanpa me-render React Native.
 */

/** 15000 → "Rp15.000" (separator ribuan titik, gaya Indonesia). */
export function formatIdr(amountIdr: number): string {
  const grouped = Math.round(amountIdr)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `Rp${grouped}`;
}

/** "+50 point" / "-1 point"; null → strip. */
export function formatCreditDelta(credit: number | null): string {
  if (credit === null) return '—';
  const sign = credit > 0 ? '+' : '';
  return `${sign}${credit} point`;
}
